export interface InventoryTransferRow {
  id: string
  code: string
  sourceWarehouse: string
  destinationWarehouse: string
}

export const INITIAL_MOCK_TRANSFERS: InventoryTransferRow[] = []

export interface TransferLine {
  id: string
  itemId: string
  batchId: string
  currentQty: number
  quantityTransfer: number
}

export function newTransferLine(): TransferLine {
  return {
    id: `${Date.now()}-${Math.random().toString(36).slice(2, 9)}`,
    itemId: '',
    batchId: '',
    currentQty: 0,
    quantityTransfer: 0,
  }
}

export function balanceQuantity(line: TransferLine): number {
  const cur = Number(line.currentQty) || 0
  const tr = Number(line.quantityTransfer) || 0
  return Math.max(0, cur - tr)
}
